import { apiFetch } from '@/utils/fetchWrapper';
import { PresenceResponse, PresenceRow } from '@/types/presence';

export const presenceService = {
  async getPresenceSnapshot(): Promise<PresenceRow[]> {
    const response = await apiFetch<PresenceResponse>('/presence/');
    return response.rows || [];
  },
};
